/* POST PLAYER v2 (2026-11-05, Rob approved mock 1, docs/feed-player-mocks-20261105.html).
   THE DOCK for every post video in the fullscreen viewer (.pfeed): one glass dock at the bottom of the viewer's chrome layer (the same
   layer as the old .vctrl transport, under the .pfeed-bar header) with the song row (an Apple Music preview on the post), a gold
   scrubber with a drag thumbnail (frames canvas-captured at 10 % steps, cached per source), the times, loop / play (gold) / sound.
   Controls fade 2.5 s after the last touch while playing; a tap on the picture toggles them (app.js hands the tap over through
   __rovaPlayer2.tap); a double-tap on the left / right third skips 10 s (__rovaPlayer2.dbl); hidden mode keeps a 3 px progress line.
   BUILT BESIDE the old transport: assets/app.js buildControls() still builds .vctrl / .vc-sound / .vc-play and fires `rova:vctrl`
   on the media; this file mounts the dock on that event (or on boot for bars already built) and DRIVES the old buttons (the play
   disc clicks .vc-play, the speaker clicks .vc-sound), so every existing rule keeps holding: song mode for a data-noaudio clip with a
   song (.vc-songsnd), the engage hold on a deliberate play, the viewer-wide sound preference, hands-free, the hidden chrome
   (.pfeed-idle) across posts. The feed card's inline clip is untouched (its single speaker + tap-to-open stay app.js's).
   Dress: assets/player2.css (the live-replay dock's glass / gold, assets/livereplay2.css). Switch: k/v post_player_v2 (views/_post.php
   emits this file only while it is on). Debug: window.__rovaPlayer2. */
(function () {
  'use strict';
  if (window.__rovaPlayer2) { return; }
  var FADE_MS = 2500, SKIP_S = 10, STEPS = 10;
  var RM = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var thumbCache = {};   // src -> { frames: [canvas|null x STEPS+1], busy, w, h }

  function el(tag, cls, attrs) {
    var n = document.createElement(tag);
    if (cls) { n.className = cls; }
    if (attrs) { for (var k in attrs) { if (attrs[k] != null) { n.setAttribute(k, attrs[k]); } } }
    return n;
  }
  function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }
  function fmt(sec) {
    var s = Math.max(0, Math.floor(sec || 0)), h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), x = s % 60;
    return (h ? h + ':' + (m < 10 ? '0' : '') + m : m) + ':' + (x < 10 ? '0' : '') + x;
  }
  function ico(name) {
    var P = {
      play: '<path d="M8 5.5v13l11-6.5z" fill="currentColor" stroke="none"/>',
      pause: '<path d="M7 5h3.4v14H7zM13.6 5H17v14h-3.4z" fill="currentColor" stroke="none"/>',
      loop: '<path d="M17 2l4 4-4 4"/><path d="M3 11V9a3 3 0 0 1 3-3h15"/><path d="M7 22l-4-4 4-4"/><path d="M21 13v2a3 3 0 0 1-3 3H3"/>',
      vol: '<path d="M4 9.5v5h3.5L12 18.5v-13L7.5 9.5z" fill="currentColor" stroke="none"/><path d="M15.5 9a4 4 0 0 1 0 6M18 6.5a7.5 7.5 0 0 1 0 11"/>',
      mute: '<path d="M4 9.5v5h3.5L12 18.5v-13L7.5 9.5z" fill="currentColor" stroke="none"/><path d="M16 9.5l5 5M21 9.5l-5 5"/>'
    };
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + (P[name] || '') + '</svg>';
  }
  function btn(cls, icon, label) { var b = el('button', 'pp2-b ' + cls, { type: 'button', 'aria-label': label, title: label }); b.innerHTML = ico(icon); return b; }
  function dur(v) { var d = v.duration; if (isFinite(d) && d > 0) { return d; } var a = parseFloat(v.getAttribute('data-dur')); return a > 0 ? a : 0; }
  function httpSrc(v) {
    var s = v.getAttribute('data-src-full') || v.getAttribute('src') || v.currentSrc || '';
    return /^(https?:)?\/\//.test(s) || /^\/[^\/]/.test(s) ? s : '';
  }

  /* ------------------------------------------------------------------ thumbnails: STEPS+1 frames per source, captured once, kept for the session ------------------------------------------------------------------ */
  function thumbsFor(v) {
    var src = httpSrc(v);
    if (!src) { return null; }
    var c = thumbCache[src];
    if (c) { return c; }
    c = thumbCache[src] = { frames: [], busy: false, src: src, done: false };
    var i; for (i = 0; i <= STEPS; i++) { c.frames.push(null); }
    return c;
  }
  function captureThumbs(v, c) {
    if (!c || c.busy || c.done) { return; }
    var d = dur(v); if (!(d > 0)) { return; }
    c.busy = true;
    var probe = el('video', '', { playsinline: '', 'webkit-playsinline': '', preload: 'auto', muted: '' });
    if (v.getAttribute('crossorigin')) { probe.setAttribute('crossorigin', v.getAttribute('crossorigin')); }
    probe.muted = true; probe.style.cssText = 'position:fixed;left:-9999px;top:-9999px;width:160px;height:90px;opacity:0;pointer-events:none';
    document.body.appendChild(probe);
    var i = 0, dead = false, tries = 0;
    var finish = function () { dead = true; c.busy = false; c.done = true; try { probe.removeAttribute('src'); probe.load(); } catch (e) {} probe.remove(); };
    var next = function () {
      if (dead) { return; }
      if (i > STEPS) { finish(); return; }
      try { probe.currentTime = Math.min(d - 0.1, (d * i) / STEPS); } catch (e) { finish(); }
    };
    probe.addEventListener('loadedmetadata', function () { c.w = probe.videoWidth || 160; c.h = probe.videoHeight || 90; next(); });
    probe.addEventListener('seeked', function () {
      if (dead) { return; }
      try {
        var w = 128, h = Math.max(24, Math.round(w * (c.h || 90) / (c.w || 160)));
        if ((c.h || 0) > (c.w || 0)) { w = 88; h = Math.round(w * c.h / c.w); }
        var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
        cv.getContext('2d').drawImage(probe, 0, 0, w, h);
        c.frames[i] = cv;
      } catch (e) {}
      i++; next();
    });
    probe.addEventListener('error', function () { if (++tries > 1 || dead) { finish(); } });
    probe.src = c.src;
    setTimeout(function () { if (!dead) { finish(); } }, 45000);   // never a probe that lives forever
  }

  /* ------------------------------------------------------------------ the dock ------------------------------------------------------------------ */
  function Dock(d) {
    this.media = d.media; this.v = d.v; this.unit = d.unit || d.media; this.bar = d.bar; this.sound = d.sound;
    this.hideT = 0; this.scrubbing = false; this.dead = false; this.lastSkipT = 0;
    this.build(); this.wire(); this.sync();
  }
  Dock.prototype.build = function () {
    var m = this.media, self = this;
    Array.prototype.forEach.call(m.querySelectorAll(':scope > .pp2, :scope > .pp2-line'), function (n) { n.remove(); });
    Array.prototype.forEach.call(this.unit.querySelectorAll(':scope > .pp2-skip'), function (n) { n.remove(); });
    m.classList.add('pp2-on'); m.classList.remove('pp2-off');
    var dock = el('div', 'pp2', { role: 'group', 'aria-label': 'Video controls' }); this.dock = dock;
    // the song row: the post's Apple Music card (never one inside a quoted post)
    var song = el('div', 'pp2-song'); song.hidden = true; this.songEl = song;
    song.innerHTML = '<img class="pp2-art" alt="" decoding="async"><div class="pp2-st"><b></b><small></small></div>';
    this.bSong = btn('pp2-sb', 'pause', 'Pause the song'); song.appendChild(this.bSong);
    dock.appendChild(song);
    var bar = el('div', 'pp2-bar', { role: 'slider', tabindex: '0', 'aria-label': 'Seek', 'aria-valuemin': '0', 'aria-valuemax': '0', 'aria-valuenow': '0' }); this.barEl = bar;
    var tip = el('div', 'pp2-tip', { 'aria-hidden': 'true' }); this.tip = tip;
    this.tipBox = el('div', 'pp2-tip-i'); this.tipT = el('div', 'pp2-tip-t'); tip.appendChild(this.tipBox); tip.appendChild(this.tipT);
    var track = el('div', 'pp2-track'); this.bufEl = el('i', 'pp2-buf'); this.fillEl = el('i', 'pp2-fill'); this.knob = el('b', 'pp2-knob');
    track.appendChild(this.bufEl); track.appendChild(this.fillEl); track.appendChild(this.knob);
    bar.appendChild(tip); bar.appendChild(track);
    dock.appendChild(bar);
    var row = el('div', 'pp2-row');
    this.tCur = el('span', 'pp2-t pp2-cur'); this.tCur.textContent = '0:00';
    this.tDur = el('span', 'pp2-t pp2-dur'); this.tDur.textContent = fmt(dur(this.v));
    this.bLoop = btn('pp2-loop', 'loop', 'Repeat'); this.bLoop.setAttribute('aria-pressed', this.v.loop ? 'true' : 'false');
    this.bPlay = btn('pp2-play', 'play', 'Play');
    this.bVol = btn('pp2-vol', 'mute', 'Sound');
    row.appendChild(this.tCur); row.appendChild(el('span', 'pp2-sp')); row.appendChild(this.bLoop); row.appendChild(this.bPlay); row.appendChild(this.bVol); row.appendChild(el('span', 'pp2-sp')); row.appendChild(this.tDur);
    dock.appendChild(row);
    m.appendChild(dock);
    var line = el('div', 'pp2-line', { 'aria-hidden': 'true' }); this.lineFill = el('i'); line.appendChild(this.lineFill); m.appendChild(line);
    this.skipL = el('div', 'pp2-skip pp2-l', { 'aria-hidden': 'true' }); this.skipL.textContent = '−10';
    this.skipR = el('div', 'pp2-skip pp2-r', { 'aria-hidden': 'true' }); this.skipR.textContent = '+10';
    this.unit.appendChild(this.skipL); this.unit.appendChild(this.skipR);
    this.song = this.findSong();
    if (this.song) {
      var art = this.song.querySelector('.am-art'), t = this.song.querySelector('.am-title'), a = this.song.querySelector('.am-artist');
      var im = song.querySelector('.pp2-art');
      if (art && art.tagName === 'IMG' && (art.currentSrc || art.src)) { im.src = art.currentSrc || art.src; } else { im.remove(); }
      song.querySelector('b').textContent = t ? t.textContent : 'Song';
      song.querySelector('small').textContent = a ? a.textContent : 'Apple Music';
      song.hidden = false;
    }
    this.sizeVar();
    if (window.ResizeObserver) { this.ro = new ResizeObserver(function () { self.sizeVar(); }); this.ro.observe(dock); }
  };
  Dock.prototype.findSong = function () {
    var p = this.media.closest('.post'); if (!p) { return null; }
    var q = this.media.closest('.quoted'), cs = p.querySelectorAll('.am-card[data-preview]'), i;
    for (i = 0; i < cs.length; i++) { if (cs[i].closest('.quoted') === q) { return cs[i]; } }
    return null;
  };
  Dock.prototype.sizeVar = function () { var h = this.dock.offsetHeight || 96, p = this.media.closest('.post'); this.media.style.setProperty('--pp2-dock-h', (h + 16) + 'px'); if (p) { p.style.setProperty('--pp2-dock-h', (h + 16) + 'px'); } };
  Dock.prototype.songOn = function () { return !!(this.song && window.__rovaAmSongOn && window.__rovaAmSongOn(this.song)); };

  Dock.prototype.wire = function () {
    var self = this, v = this.v, m = this.media, bar = this.barEl;
    var on = function (n, ev, f, o) { n.addEventListener(ev, f, o); self.offs.push(function () { n.removeEventListener(ev, f, o); }); };
    this.offs = [];
    // transport: the old buttons carry the rules (engage hold, user-paused, song mode), so the dock drives them
    on(this.bPlay, 'click', function (e) { e.stopPropagation(); var b = self.bar && self.bar.querySelector('.vc-play'); if (b) { b.click(); } else if (v.paused) { v.play().catch(function () {}); } else { v.pause(); } self.show(); });
    on(this.bVol, 'click', function (e) { e.stopPropagation(); if (self.sound) { self.sound.click(); } else { v.muted = !v.muted; } self.show(); setTimeout(function () { self.syncSound(); }, 60); });
    on(this.bSong, 'click', function (e) { e.stopPropagation(); if (self.sound && self.sound.classList.contains('vc-songsnd')) { self.sound.click(); } else if (self.song) { var pb = self.song.querySelector('.am-play'); if (pb) { pb.click(); } } self.show(); setTimeout(function () { self.syncSound(); }, 60); });
    on(this.bLoop, 'click', function (e) { e.stopPropagation(); v.loop = !v.loop; self.bLoop.setAttribute('aria-pressed', v.loop ? 'true' : 'false'); self.show(); });
    ['play', 'pause', 'playing', 'emptied', 'loadstart', 'canplay'].forEach(function (ev) { on(v, ev, function () { self.syncPlay(); }); });
    on(v, 'timeupdate', function () { if (!self.scrubbing) { self.syncTime(); } });
    on(v, 'durationchange', function () { self.syncTime(); self.syncShape(); });
    on(v, 'loadedmetadata', function () { self.syncShape(); self.syncTime(); });
    on(v, 'progress', function () { self.syncBuf(); });
    on(v, 'volumechange', function () { self.syncSound(); });
    if (this.sound && window.MutationObserver) { this.mo = new MutationObserver(function () { self.syncSound(); }); this.mo.observe(this.sound, { attributes: true, attributeFilter: ['aria-pressed', 'class'] }); }
    // any touch on the dock or the action rail keeps the controls up
    on(this.dock, 'pointerdown', function () { self.show(); });
    on(this.dock, 'pointermove', function () { self.show(); });
    on(this.dock, 'click', function (e) { e.stopPropagation(); });
    if (this.bar) { on(this.bar, 'pointerdown', function () { self.show(); }); }
    // scrubbing: pointer capture on the bar; the video seeks on release (the thumbnail and the time follow the pointer)
    var frac = function (e) { var r = bar.getBoundingClientRect(); return clamp((e.clientX - r.left) / Math.max(1, r.width), 0, 1); };
    on(bar, 'pointerdown', function (e) {
      if (e.button != null && e.button > 0) { return; }
      e.preventDefault(); e.stopPropagation();
      self.scrubbing = true; m.classList.add('pp2-scrub'); self.show();
      try { bar.setPointerCapture(e.pointerId); } catch (x) {}
      captureThumbs(v, thumbsFor(v));
      self.scrubTo(frac(e), e.clientX);
    });
    on(bar, 'pointermove', function (e) { if (self.scrubbing) { e.preventDefault(); self.scrubTo(frac(e), e.clientX); } });
    var up = function (e) {
      if (!self.scrubbing) { return; }
      self.scrubbing = false; m.classList.remove('pp2-scrub');
      try { bar.releasePointerCapture(e.pointerId); } catch (x) {}
      var d = dur(v); if (d > 0) { try { v.currentTime = clamp(frac(e) * d, 0, Math.max(0, d - 0.05)); } catch (x2) {} }
      self.syncTime(); self.show();
    };
    on(bar, 'pointerup', up); on(bar, 'pointercancel', function (e) { self.scrubbing = false; m.classList.remove('pp2-scrub'); self.syncTime(); });
    on(bar, 'keydown', function (e) {
      var k = e.key, h = true;
      if (k === 'ArrowLeft') { self.skip(-5); } else if (k === 'ArrowRight') { self.skip(5); } else if (k === 'Home') { self.seekTo(0); } else if (k === 'End') { self.seekTo(dur(v) - 1); } else { h = false; }
      if (h) { e.preventDefault(); e.stopPropagation(); }
    });
  };
  Dock.prototype.scrubTo = function (f, clientX) {
    var d = dur(this.v), t = f * d;
    this.fillEl.style.transform = 'scaleX(' + f + ')'; this.knob.style.left = (f * 100) + '%'; this.lineFill.style.width = (f * 100) + '%';
    this.tCur.textContent = fmt(t); this.tipT.textContent = fmt(t);
    var br = this.barEl.getBoundingClientRect(), w = this.tip.offsetWidth || 70;
    this.tip.style.left = clamp(clientX - br.left, w / 2, Math.max(w / 2, br.width - w / 2)) + 'px';
    this.thumbAt(f);
  };
  Dock.prototype.thumbAt = function (f) {
    var c = thumbsFor(this.v), box = this.tipBox, i = Math.round(f * STEPS), fr = null, j;
    if (c) { for (j = 0; j <= STEPS && !fr; j++) { fr = c.frames[i - j] || c.frames[i + j] || null; } }   // the nearest frame already captured
    if (fr) { if (box.firstChild !== fr) { box.innerHTML = ''; box.appendChild(fr); } return; }
    var ps = this.v.getAttribute('poster');
    if (ps && !box.querySelector('img')) { box.innerHTML = ''; var im = el('img', '', { alt: '', decoding: 'async' }); im.src = ps; box.appendChild(im); }
  };
  Dock.prototype.seekTo = function (t) { var d = dur(this.v); if (!(d > 0)) { return; } try { this.v.currentTime = clamp(t, 0, Math.max(0, d - 0.05)); } catch (e) {} this.syncTime(); this.show(); };
  Dock.prototype.skip = function (s) { this.seekTo((this.v.currentTime || 0) + s); };
  Dock.prototype.flash = function (side) {
    var n = side < 0 ? this.skipL : this.skipR, self = this;
    n.classList.add('pp2-in'); clearTimeout(n._t); n._t = setTimeout(function () { n.classList.remove('pp2-in'); }, 650);
    if (navigator.vibrate && !RM) { try { navigator.vibrate(8); } catch (e) {} }
    self.show();
  };

  /* fade: 2.5 s after the last touch while playing; paused = always shown */
  Dock.prototype.show = function () {
    var self = this;
    this.media.classList.remove('pp2-off');
    clearTimeout(this.hideT);
    if (!this.v.paused && !this.scrubbing) { this.hideT = setTimeout(function () { if (!self.v.paused && !self.scrubbing && !self.dead) { self.media.classList.add('pp2-off'); } }, FADE_MS); }
  };
  Dock.prototype.hide = function () { clearTimeout(this.hideT); this.media.classList.add('pp2-off'); };
  Dock.prototype.toggle = function () { if (this.media.classList.contains('pp2-off')) { this.show(); } else { this.hide(); } };

  Dock.prototype.syncPlay = function () {
    var p = this.v.paused;
    this.bPlay.innerHTML = ico(p ? 'play' : 'pause'); this.bPlay.setAttribute('aria-label', p ? 'Play' : 'Pause'); this.bPlay.title = p ? 'Play' : 'Pause';
    if (p) { this.media.classList.remove('pp2-off'); clearTimeout(this.hideT); } else { this.show(); }
  };
  Dock.prototype.syncTime = function () {
    var v = this.v, d = dur(v), t = v.currentTime || 0, f = d > 0 ? clamp(t / d, 0, 1) : 0;
    this.fillEl.style.transform = 'scaleX(' + f + ')'; this.knob.style.left = (f * 100) + '%'; this.lineFill.style.width = (f * 100) + '%';
    this.tCur.textContent = fmt(t); this.tDur.textContent = fmt(d);
    this.barEl.setAttribute('aria-valuemax', String(Math.round(d))); this.barEl.setAttribute('aria-valuenow', String(Math.round(t))); this.barEl.setAttribute('aria-valuetext', fmt(t) + ' of ' + fmt(d));
    this.syncBuf();
  };
  Dock.prototype.syncBuf = function () {
    var v = this.v, d = dur(v), b = v.buffered, t = v.currentTime || 0, e = 0, i;
    if (!(d > 0)) { return; }
    try { for (i = 0; i < b.length; i++) { if (b.start(i) <= t + 0.5 && b.end(i) >= t) { e = b.end(i); } } } catch (x) {}
    this.bufEl.style.transform = 'scaleX(' + clamp(Math.max(e, t) / d, 0, 1) + ')';
  };
  Dock.prototype.syncSound = function () {
    var v = this.v, m;
    if (this.sound && this.sound.getAttribute('aria-pressed') != null) { m = this.sound.getAttribute('aria-pressed') === 'true'; }
    else if (this.song && this.sound && this.sound.classList.contains('vc-songsnd')) { m = !this.songOn(); }
    else { m = v.muted || v.volume === 0; }
    this.bVol.innerHTML = ico(m ? 'mute' : 'vol'); this.bVol.setAttribute('aria-label', m ? 'Sound off. Turn it on' : 'Mute'); this.bVol.setAttribute('aria-pressed', m ? 'false' : 'true');
    if (this.song) { var on = this.songOn(); this.bSong.innerHTML = ico(on ? 'pause' : 'play'); this.bSong.setAttribute('aria-label', on ? 'Pause the song' : 'Play the song'); }
  };
  Dock.prototype.syncShape = function () { var v = this.v; if (v.videoWidth && v.videoHeight) { this.media.classList.toggle('pp2-portrait', v.videoHeight > v.videoWidth); } };
  Dock.prototype.sync = function () { this.syncPlay(); this.syncTime(); this.syncSound(); this.syncShape(); this.show(); };
  Dock.prototype.destroy = function () {
    this.dead = true; clearTimeout(this.hideT);
    (this.offs || []).forEach(function (f) { f(); });
    if (this.mo) { this.mo.disconnect(); } if (this.ro) { this.ro.disconnect(); }
    this.dock.remove(); var l = this.media.querySelector(':scope > .pp2-line'); if (l) { l.remove(); }
    this.skipL.remove(); this.skipR.remove();
    this.media.classList.remove('pp2-on', 'pp2-off', 'pp2-scrub', 'pp2-portrait'); this.media.style.removeProperty('--pp2-dock-h');
    this.media.__pp2 = null;
  };

  /* ------------------------------------------------------------------ mount / boot ------------------------------------------------------------------ */
  function mount(d) {
    if (!d || !d.media || !d.v || !d.media.closest || !d.media.closest('.pfeed')) { return null; }
    if (d.media.__pp2) { if (d.media.__pp2.v === d.v && d.media.__pp2.dock.isConnected) { return d.media.__pp2; } d.media.__pp2.destroy(); }
    try { var k = new Dock(d); d.media.__pp2 = k; return k; } catch (e) { if (window.console) { console.error('[player2]', e); } return null; }
  }
  function dockOf(media) { var k = media && media.__pp2; return (k && !k.dead && k.dock.isConnected) ? k : null; }
  document.addEventListener('rova:vctrl', function (e) { mount(e.detail || {}); });
  function boot() {
    var ns = document.querySelectorAll('.pfeed .has-vctrl'), i;
    for (i = 0; i < ns.length; i++) {
      var m = ns[i], v = m._vctrl; if (!v) { continue; }
      mount({ media: m, v: v, bar: m.querySelector(':scope > .vctrl'), sound: m.querySelector(':scope > .vc-sound'), unit: m.classList.contains('pf-cbar') ? (m.closest('.carousel') || m) : m });
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  window.__rovaPlayer2 = {
    mount: mount, boot: boot, thumbs: thumbCache,
    /* app.js: a single tap on the picture of a mounted clip toggles the controls (true = handled) */
    tap: function (media) { var k = dockOf(media); if (!k) { return false; } k.toggle(); return true; },
    /* app.js: a double-tap at clientX on the left / right third skips 10 s (true = handled; the middle keeps the like) */
    dbl: function (media, clientX) {
      var k = dockOf(media); if (!k || typeof clientX !== 'number') { return false; }
      var r = (k.unit || media).getBoundingClientRect(), f = (clientX - r.left) / Math.max(1, r.width);
      if (f < 0.34) { k.skip(-SKIP_S); k.flash(-1); return true; }
      if (f > 0.66) { k.skip(SKIP_S); k.flash(1); return true; }
      return false;
    }
  };
})();
